// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xQfO","buttons":"Footer_buttons__CuumX"};